import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Offer } from './pages/Offer';
import { Legal } from './pages/Legal';
import { SeoManager } from './seo/SeoManager';
import { captureAttribution } from './offers/attribution';
import { LanguageProvider } from './i18n/LanguageContext';
const METRICOOL_HASH = 'df4ba11b5f84ffc1f3c2fca17f7e75d4';

// ============================================================
// META PIXEL
// Pega aqui el ID cuando crees el pixel de Blinkblis.
// Mientras este vacio no se inyecta nada y el sitio funciona igual.
// ============================================================
const META_PIXEL_ID = '';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Guarda los parametros del anuncio apenas entra, antes de que
// cualquier navegacion interna los borre de la URL.
function AttributionCapture() {
  const {
    search
  } = useLocation();
  useEffect(() => {
    captureAttribution();
  }, [search]);
  return null;
}

// Redirect que NO pierde el query string.
// Sin esto, /credito?utm_campaign=123 llegaba a /oferta/credito pelado
// y se perdia la atribucion antes de que el usuario tocara nada.
function RedirectKeepQuery({
  to
}: {
  to: string;
}) {
  const {
    search
  } = useLocation();
  return <Navigate to={`${to}${search}`} replace data-id="element-0" data-mp="2zm4xcjfp5b1a" />;
}
export function App() {
  useEffect(() => {
    if (document.getElementById('metricool-tracker')) return;
    const script = document.createElement('script');
    script.id = 'metricool-tracker';
    script.type = 'text/javascript';
    script.src = 'https://tracker.metricool.com/resources/be.js';
    const init = () => {
      const w = window as unknown as {
        beTracker?: {
          t: (opts: {
            hash: string;
          }) => void;
        };
      };
      if (w.beTracker) w.beTracker.t({
        hash: METRICOOL_HASH
      });
    };
    script.onload = init;
    (script as any).onreadystatechange = init;
    document.getElementsByTagName('head')[0].appendChild(script);
  }, []);
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.getElementsByTagName('head')[0].appendChild(t);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <LanguageProvider data-id="element-1" data-mp="3ljg1tta8ud2s">
      <BrowserRouter data-id="element-2" data-mp="3liwm8j82g0rx">
        <ScrollToTop data-id="element-3" data-mp="3limrkic2t5fw" />
        <AttributionCapture data-id="element-4" data-mp="2xun4pthvxz6l" />
        <SeoManager data-id="element-5" data-mp="2xtv8cgggrxf9" />
        <Routes data-id="element-6" data-mp="2xtbvvf9l218m">
          <Route path="/" element={<Home data-id="element-8" data-mp="2sw207hvlotcc" />} data-id="element-7" data-mp="2xssjee2pc51z" />

          {/* Ofertas: cada slug de offers/config.ts vive aqui.
              /oferta/<slug> es la URL canonica. */}
          <Route path="/oferta/:slug" element={<Offer data-id="element-10" data-mp="18bya08vkyh24" />} data-id="element-9" data-mp="18cznsl3zdhnj" />

          {/* Atajo corto para bios de redes. Conserva el query string. */}
          <Route path="/credito" element={<RedirectKeepQuery to="/oferta/credito" data-id="element-12" data-mp="ygmx7w3qfjx0" />} data-id="element-11" data-mp="1d6awysw9maim" />

          {/* Legales: privacidad, terminos, metodologia,
              estandares-editoriales, divulgacion-de-afiliados */}
          <Route path="/:slug" element={<Legal data-id="element-14" data-mp="1r526s343ha0y" />} data-id="element-13" data-mp="1r5al7zfv8ne9" />

          <Route path="*" element={<Navigate to="/" replace data-id="element-16" data-mp="1w3vltzz15938" />} data-id="element-15" data-mp="1r2g2qdgexcnh" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}